import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store, useStore } from './store'
import ElementPlus from 'element-plus'
import 'dayjs/locale/zh-cn'
import '@/utils/formatTime'
import 'nprogress/nprogress.css'
import 'element-plus/dist/index.css'
// import './scss/element-variables.scss'
import './scss/index.scss';
import './scss/font/iconfont.css';
import role from '@/directives/role'
import dialogDrag from '@/directives/dialogDrag'
import '@/permission'
import 'default-passive-events'
import "@/scss/font/iconfont.js"
// @ts-ignore
import SvgIcon from "@/components/SvgIcon/index.vue";
import {usePathTokenTologin} from "@/utils/utils";
import { Vue } from 'vue-class-component'

const app = createApp(App)
app.component('SvgIcon',SvgIcon)
app.use(store).use(router).use(ElementPlus).mount('#app')
app.directive('role', role);
//注入token处理
usePathTokenTologin();